import { List, Map } from 'immutable'

import {
  FETCH_STATS,
  SET_STATS_DOMAIN,
  SET_STATS_INTERVAL,
  FETCH_CURRENT_USER,
  ARTICLE_EXCLUDED,
} from '../actions'

export default function video(state = {
  interval: 'hourly',
  page: 1,
}, action) {
  switch (action.type) {
    case FETCH_CURRENT_USER:
      if (action.payload.isFetching) {
        return state
      }
      return { ...state,
        domain: action.payload.domains && action.payload.domains.length ? action.payload.domains[0] : null,
      }
    case ARTICLE_EXCLUDED:
      const embedIdx = state.embeds.findIndex(e => e.article === action.payload.article && e.shortcode === action.payload.shortcode)
      return { ...state,
        embeds: List(state.embeds).set(embedIdx, Map(state.embeds[embedIdx]).set('selected', action.payload.excluded).toObject()).toArray(),
      }
    case FETCH_STATS:
      return { ...state, ...action.payload }
    case SET_STATS_DOMAIN:
      return { ...state,
        domain: action.payload,
      }
    case SET_STATS_INTERVAL:
      return { ...state,
        interval: action.payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stats.js